import { createContext, useState } from "react";

export const LicensingAgencyContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [licensingAgencies, setLicensingAgencies] = useState([]);

    // Make the context object:
    const licensingAgencyContext = {
        licensingAgencies,
        setLicensingAgencies,
    };

    // pass the value in provider and return
    return <LicensingAgencyContext.Provider value={licensingAgencyContext}>{children}</LicensingAgencyContext.Provider>;
};

export const { Consumer } = LicensingAgencyContext;
